import { PathGroup, UserGroup } from '../path-group/path-group.model'
import { Base } from '../shared/base'
import { Survey } from '../survey/survey.model'
import { Theme } from '../theme/theme.model'
import { hexToRgb, shadeColor } from '../utils.service'
import { PathClient } from './path-client.model'
import { DailySteps, ScreenTypes, Step } from './path-daily-steps-v2.model'

export interface ColoursAttributes {
  [name: string]: string
}
export interface NamesAttributes {
  [name: string]: string
}
export interface EnabledAttributes {
  [section: string]: any
}

export interface Streaks {
  five_day_weaks: number,
  straight_weeks: number,
  streak_dates: string[],
  todays_streak: boolean,
  weekly_streak_completed: boolean,
  weekly_streak_days_count: number

}

export interface KyperChapters {
  id: number,
  name: string,
  position: number,
  steps: DailySteps[]
}

export interface CurrentStep {
  position: number,
  stepStatus: String,
  originalStep: number,
  chapterStepIndex: number,
  step: Step
}
export interface CurrentChapter {
  id: number,
  name: string,
  position: number,
  currentStep: CurrentStep
}
export interface DeselectedChapters {
  id: number,
  name: string
}

export interface ChaptersInfo {
  chapterOrder: string[],
  id: number,
  stepsCompletedInChapter: number
}
export class Path extends Base {
  init() {
    this._fields = [
      'id', 'clientId', 'currentChapter', 'pathGroup', 'name',
      'daysOfTheWeek', 'logoImage', 'signupEnabled',
      'streaks', 'signupEmail', 'language','scheduleDay','isKyperPathCompleted','deselectedChapters',
      'daysOfContent', 'starts', 'ends', 'colours', 'names',
      'enabledAttributes', 'client', 'pathImage', 'kyperChapters', 'userChapter'
    ]

    this._defaultInput = { exclude: ['client'] }

    this._nestedFields = {
      client: PathClient,
    }

    // Defaults
    // Initialization of all nested objects is required
    this.names = {}
    this.currentChapter = {} as CurrentChapter
    this.streaks = {} as Streaks
    this.colours = {
      themeheader: '#FFFFFF',
      highlightheader: '#FFFFFF',
      header: '#FFFFFF',
      theme: '#54BDAF',
      highlight: '#54BDAF',
      stat1: '#575757',
      stat2: '#C8FA0A',
      stat3: '#00A0DC',
      stat4: '#6E1E78',
      stat5: '#E63264'
    }

    this.enabledAttributes = {}
    this.kyperChapters = []
    this.deselectedChapters =[]
    this.userChapter = {} as ChaptersInfo
  }

  afterInit() {
    // this.chapters = this.chapters.filter(chapter => chapter.enabled)

    // try {
    //   this.colours['highlight-faded'] = hexToRgb(this.colours['highlight'], .5)
    //   this.colours['stat1-shaded'] = shadeColor(this.colours['stat1'], -.2)
    //   this.colours['stat2-shaded'] = shadeColor(this.colours['stat2'], -.2)
    //   this.colours['stat3-shaded'] = shadeColor(this.colours['stat3'], -.2)
    //   this.colours['stat4-shaded'] = shadeColor(this.colours['stat4'], -.2)
    //   this.colours['stat5-shaded'] = shadeColor(this.colours['stat5'], -.2)
    // } catch (e) {}
    this.setTheme()
  }

  public id: number
  public clientId: number
  public pathGroup: PathGroup
  public name: string
  public daysOfTheWeek: number
  public logoImage: string
  public signupEnabled: boolean
  public signupEmail: string
  public daysOfContent: number
  public starts: string
  public ends: string
  public colours: ColoursAttributes
  public names: NamesAttributes
  public enabledAttributes: EnabledAttributes
  public streaks: Streaks
  public language: string
  public client: PathClient
  // public users: User[]
  public enabled: boolean
  public theme: Theme
  public pathImage: string
  public kyperChapters: KyperChapters[]
  public currentChapter: CurrentChapter
  public userChapter: ChaptersInfo
  public deselectedChapters: any[]
  public getCustomText(identifier: string): string {
    return this.names && this.names[identifier] ? this.names[identifier] : ''
  }

  public update(key, id, diff) {
    if (!this.hasOwnProperty(key)) { return false }
    console.log(this[key]);
    const element = this[key].find(elem => elem.id === id)
    if (element) {
      return Object.assign(element, diff)
    }
  }

  public setTheme() {
    const variables = {}
    if (this.colours) {
      for (const variableName of Object.keys(this.colours)) {
        variables[`--${variableName}-color`] = this.colours[variableName]
      }
    }

    const fonts = []
    if (this.client && this.client.bodyFontUrl) {
      const bodyFontName = `client${this.client.id}BodyFont`
      fonts.push({ name: bodyFontName, url: this.client.bodyFontUrl })
      variables['--body-font'] = bodyFontName
    }
    if (this.client && this.client.headerFontUrl) {
      const headerFontName = `client${this.client.id}HeaderFont`
      fonts.push({ name: headerFontName, url: this.client.headerFontUrl })
      variables['--header-font'] = headerFontName
    }
    if (this.client && this.client.backgroundImageUrl) {
      variables['--client-background'] = `url(${this.client.backgroundImageUrl})`
    } else { // LUMBA-1389
      variables['--client-background'] = 'url(assets/images/default-background.jpg)'
    }

    this.theme = new Theme(variables, fonts)
  }

  public getTheme(): Theme {
    return this.theme
  }

  lastDayOfContent(): number {
    if (!this.kyperChapters || this.kyperChapters.length === 0) return 0;

    return this.kyperChapters.reduce((total, chapter) => {
      const stepCount = chapter.steps ? chapter.steps.length : 0;
      return total + stepCount;
    }, 0);
  }
   public checkContentForDay(day: number) {
    // const survey = this.dailySteps[day-1]?.contentSurveys
    // if (survey) { return true }
    // const poll = this.dailySteps[day-1]?.polls
    // if (poll && poll?.length>0) { return true }
    // const habit = this.dailySteps[day-1]?.habits
    // if (habit) { return true }
    // const question = this.dailySteps[day-1]?.questions
    // if (question) { return true }
    // const document =this.dailySteps[day-1]?.documents
    // if (document) { return true }
    // const routine = this.dailySteps[day-1]?.routineInfo
    // if (routine) { return true }
    // const inout =this.dailySteps[day-1]?.inoutScreens
    // if (inout) { return true }
    // const todo = this.dailySteps[day-1]?.toDos
    // if (todo) { return true }
    // const reflection = this.dailySteps[day-1]?.reflections
    // if (reflection) { return true }
    // const onboardingSettings = this.dailySteps[day-1]?.onboardingSteps
    // if (onboardingSettings && onboardingSettings?.length>0) { return true }
    // return false
    return false;
  }
  public checkMandatoryForDay(day: number) {
    return false;
  }
  getLocalStepIndex(chapters, activeChapterIndex, scheduleDay) {
  let totalBefore = 0;
   scheduleDay = scheduleDay || 1;
  for (let i = 0; i < activeChapterIndex; i++) {
    totalBefore += chapters[i]?.steps?.length || 0;
  }

  return activeChapterIndex>1?scheduleDay - totalBefore : scheduleDay ; // local step index
  }
  areAllChaptersStepsReviewed(dailyStepsArray) {
    return dailyStepsArray.every(chapter =>
      chapter.steps.every(step => step.stepStatus === "Review")
    );
  }

    filterStepsByContentType(type: ScreenTypes,activeStep) {
        const screens = activeStep?.screens;
        if (type && screens?.length > 0) {
          // Return only screens matching the screenType
          return screens
            ?.filter(screen => screen?.screenType === type)
            .map(screen => ({
              screen: screen?.screenContents,
              step: activeStep?.position,
              stepId: activeStep?.step?.id,
              screenId: screen?.id,
              screenContentId: screen?.screenContents?.id,
              screenPosition: screen?.position,
              assets:screen?.assets
            }));
        }
      
      return (type == 'content' || type == 'poll') ? [] : null;
    }
  
  findChapterStepByScreenContentId(chapters: any[], screenContentId: number,isScreenId?) {
    for (let chapterIndex = 0; chapterIndex < chapters?.length; chapterIndex++) {
      const chapter = chapters[chapterIndex];

      for (let stepIndex = 0; stepIndex < chapter.steps.length; stepIndex++) {
        const step = chapter.steps[stepIndex];
        const stepPosition =chapter.steps[stepIndex]?.position
        const screenIndex = step.screens.findIndex(
          screen => !isScreenId?screen?.screenContents?.id === screenContentId : screen?.id === screenContentId
        );

        if (screenIndex !== -1) {
          return {
            stepPosition,
            chapterIndex,
            stepIndex
          };
        }
      }
    }

    return null; 
  }

  findChapterAndStepIndex(chapters: any[], stepPosition: number) {
    for (let chapterIndex = 0; chapterIndex < chapters.length; chapterIndex++) {
      const steps = chapters[chapterIndex]?.steps || [];

      const stepIndex = steps.findIndex(
        (step) => step?.position === stepPosition
      );

      if (stepIndex !== -1) {
        return {
          chapterIndex,
          stepIndex
        };
      }
    }

    return null;
  }

}
